/* eslint-disable @typescript-eslint/naming-convention */

import JTableCell from '@atoms/JTabelCell';
import { EstablishmentCreditTopUp } from '@establishment/models/get-credit-topup';
import { formatDate } from '@lib/dateUtils';
import { TableRowStyled } from '@styled/table-row.styled';

interface Props {
  row: EstablishmentCreditTopUp;
}

const RechargeTableRow = ({ row }: Props) => {
  const { id, createdAt, eurosAmount, creditsAmount, creditsSharing } = row;

  return (
    <TableRowStyled key={id} data-test={`recharge-list-row-${id}`}>
      <JTableCell>{formatDate(createdAt)}</JTableCell>
      <JTableCell>{`${eurosAmount} €`}</JTableCell>
      <JTableCell>{creditsAmount}</JTableCell>
      <JTableCell>{formatDate(creditsSharing[0].createdAt)}</JTableCell>
      <JTableCell>{creditsSharing[0].creditsAmount}</JTableCell>
    </TableRowStyled>
  );
};

export default RechargeTableRow;
